export default "__VITE_ASSET__5af30c4d__"